import * as R from 'ramda';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
//////////////////////////////////////////////////

const getAvailableRateDisplayedValuesText = (collectionPath) => (item) => {
  const collection = R.path(collectionPath, item);

  if (G.isNilOrEmpty(collection)) return '';

  return R.compose(
    R.join(', '),
    R.map(R.prop(GC.FIELD_DISPLAYED_VALUE)),
  )(collection);
};

export const getGrantedEnterprisesText = (item) => {
  const grantedEnterprises = R.prop(GC.SYSTEM_LIST_GRANTED_ENTERPRISES, item);

  if (G.isNilOrEmpty(grantedEnterprises)) return '';

  return G.createStringFromArray(grantedEnterprises, ', ');
};

export const availableRateFilters = {
  [`${GC.FIELD_PRICE}.${GC.FIELD_NAME}`]: {
    type: 'string',
    getFieldUiValue: R.path([GC.FIELD_PRICE, GC.FIELD_NAME]),
  },
  [GC.FIELD_MODE]: {
    type: 'string',
    getFieldUiValue: R.path([GC.FIELD_PRICE, GC.FIELD_MODE, GC.FIELD_DISPLAYED_VALUE]),
  },
  [GC.FIELD_TOTAL]: {
    type: 'number',
    shouldRound: true,
    getFieldUiValue: R.path([GC.SYSTEM_OBJECT_NORMALIZED_TOTAL, GC.FIELD_TOTAL]),
  },
  [GC.FIELD_TRANSIT_DAYS]: {
    type: 'number',
    getFieldUiValue: R.path([GC.FIELD_PRICE, GC.FIELD_TRANSIT_DAYS]),
  },
  [GC.FIELD_CARRIER_EQUIPMENTS]: {
    type: 'string',
    getFieldUiValue: getAvailableRateDisplayedValuesText([
      GC.FIELD_PRICE,
      GC.FIELD_CARRIER_EQUIPMENTS,
    ]),
  },
  [GC.FIELD_GRANTED_TO_CUSTOMER]: {
    type: 'boolean',
    getFieldUiValue: R.compose(G.isNotNilAndNotEmpty, R.prop(GC.SYSTEM_LIST_GRANTED_ENTERPRISES)),
  },
  [GC.SYSTEM_LIST_GRANTED_ENTERPRISES]: {
    type: 'string',
    getFieldUiValue: getGrantedEnterprisesText,
  },
  [GC.FIELD_TRANSPORTING_CARRIER]: {
    type: 'string',
    getFieldUiValue: R.path([GC.FIELD_TRANSPORTING_CARRIER, GC.FIELD_NAME]),
  },
  [GC.FIELD_CARRIER_SERVICE_TYPES]: {
    type: 'string',
    getFieldUiValue: getAvailableRateDisplayedValuesText([
      GC.FIELD_PRICE,
      GC.FIELD_CARRIER_SERVICE_TYPES,
    ]),
  },
};
